// //////////////////////////////
// Data Set
// //////////////////////////////
// DataSet객체

class ObjDataSet {
    constructor (name) {
        this.DataSetName = name;
        this.Header = "";
        this.dataIdx = 0;
        this.CountColumn = 0;
        this.CountRow = 0;
        this.ColID = [];
        this.DataRows = [];
        this.ClearAll();
    }
    // 객체 초기화 시키기
    ClearAll() {
        // this.DataSetName = "";// Name은 Clear시키지 않음.
        this.Header = "";
        this.dataIdx = 0;
        this.CountColumn = 0;
        this.CountRow = 0;
        this.ColID = [];
        this.DataRows = [];
        // 그리드와 연결된 부분들
        this.ClearData();// 연결된 그리드데이터 삭제
    }

    SetDataHeader (arg) {
        this.Header = arg;
    }

    // //////////// dataSet에 row 추가삭제 기능. ///////////////////
    // 데이터셋에 로우추가
    AddRow() {
        var obj = {};
        obj.SYSSTATUS = 1;// 1=insert, 2=delete, 3=update
        obj.ROWID = ++this.dataIdx;
        this.DataRows.push(obj);
        this.CountRow = this.DataRows.length;
    }

    DeleteRow(row) {
        if (this.DataRows == null) return;
        // delete this.DataRows[row-1]; 실제로 지우지는 않음.

        var arrObj = this.DataRows[ row - 1 ];
        arrObj["SYSSTATUS"] = 2;// 1=insert, 2=delete, 3=update
        this.DataRows[ row - 1 ] = arrObj;
    }

    // DataSet내에 DataRows지우기
    ClearData () {
        this.dataIdx = 0;
        this.CountRow = 0;
        this.DataRows = [];
    }

    // //////////////////////////////////////////////
    SysStatus (row) {
        if (this.DataRows == null) return;

        var arrObj = this.DataRows[ row - 1 ];
        return arrObj["SYSSTATUS"];// 1=insert, 2=delete, 3=update
    }

    // ///////////////// RowPosition과 컬럼이름으로 Row에 값 넣고 빼기 ///////////////////
    // Row, 컬럼명 위치에 인자로 온 값할, 값 구해오기 setValue라고 생각하면 됨.
    NameString (argIdx, argName, argValue) {
        var arrObj = this.DataRows[ argIdx - 1 ];
        arrObj[argName] = argValue;
        this.DataRows[ argIdx - 1 ] = arrObj;
    }

    // row 컬럼명으로 해당위치 값을 가져옴. NameString = setValue
    getValue (argIdx, argName) {
        if (this.DataRows == null) return "";

        var arrObj = this.DataRows[ argIdx - 1 ];
        return (arrObj[argName] == null) ? "" : arrObj[argName];
    }

    // ///////// RowPosition과 column position으로 Row에 값 넣고 빼기 /////////
    getColumnString (row, col) {
        if (this.DataRows == null) return "";
        if (col < 1 || row < 1) return "";

        var colName = this.ColID[ col - 1 ];
        var arrObj = this.DataRows[ row - 1 ];

        if (arrObj[colName] == null) return "";

        return arrObj[colName] + "";// string으로 보낸다.
    }

    setColumnString (row, col, value) {
        if (this.DataRows == null) return "";
        if (col < 1 || row < 1) return "";

        var colName = this.ColID[ col - 1 ];
        var arrObj = this.DataRows[ row - 1 ];

    console.log("setColumnString-colName:" + colName + ", value-" + value);
        arrObj[colName] = value;
        this.DataRows[ row - 1 ] = arrObj;

    }

    // ///////// RowID로 전체 Row Data가져오기, 이 rowid는 그리드의 rowid가 아님.  /////////
    getRowDataByRowID (rowid) {
        if (this.DataRows == null) return "";

        for (var i = 0; i < this.DataRows.length; i++) {
            var rowObj = this.DataRows[i];
            if (rowObj.ROWID === rowid) return rowObj;
        }

        return null;
    }

    ColumnID(col) {
        if (this.ColID == null) return "";
        return this.ColID[ col - 1 ];
    }
    
    isEmpty () {
        if (this.DataRows == null) return true;
        else return (this.DataRows.length === 0);
    }

    initDataSet(dataset) {
        dataset.ClearAll();
    }

}

export default ObjDataSet;
